import React from 'react';
import useStyles from '../../../../style/js-style/containers/administration/personalization/personalizationStyle';

const InputWrapper = ({ inputItem, children }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.inputWrapper}>
      <div className={classes.inputItemLabelWrapper}>
        <div className={classes.inputItemTitle}>{inputItem.title}</div>
        <div className={classes.inputItemNotice}>{inputItem.notice}</div>
      </div>
      <div className={classes.inputItemInputWrapper}>
        {children}
      </div>
    </div>
  );
}

export default InputWrapper;